import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
} from 'reactstrap';
import { Tooltip } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { connect } from 'react-redux';
import Select from 'react-select';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import {
  postAPI_Create_Forms,
  postAPI_CreateFormLanguageVersion,
  putAPI_UpdateFormLanguageVersion,
  putAPI_Update_Forms,
  gAPI_QuestionSets,
  gAPI_FormsBy_Id,
  gAPI_FormLanguageVersion_ByFormAndLanguage,
  deleteAPI_FormLanguageVersions_By_FormId,
  gAPI_FormsCategoryList,
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import CategoryTag from './CategoryTag';
import { TabContent, TabPane } from 'reactstrap';
import LanguageTabs from '../../components/LanguageTabs/LanguageTabs';
import {
  faCopy,
  faCheck,
  faTrashAlt,
  faEdit,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Title } from '@mui/icons-material';

const mediaTypeList = [
  { label: 'JPG/JPEG', value: 'jpg' },
  { label: 'PNG', value: 'png' },
  { label: 'GIF', value: 'gif' },
  { label: 'DOC', value: 'doc' },
  { label: 'PDF', value: 'pdf' },
];

function Forms({
  visible,
  formLabel,
  toggle,
  id,
  propertyId,
  locale,
  LoadData,
  languageCode,
  service,
  categoryList,
  isSuperAdmin,
}) {
  const [inputData, setInputData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId === '-1' ? null : propertyId,
    name: '',
    formType: '0',
    formContent: '',
    languageCode: languageCode,
    subject: '',
    subTitle: '',
    successMessage: '',
    status: 'Active',
    isGlobal: false,
    categories: [],
    creator: 'dashboard',
  });
  const [uploadData, setUploadData] = useState([]);
  const [globelToolTip, setGlobelToolTip] = useState(false);
  const [error, setError] = useState({ msg: '', visible: false });
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [categoryTag, setCategoryTag] = useState(categoryList);
  const [selectedTag, setSelectedTag] = useState([]);
  const [addTagModel, setAddTagModel] = useState(false);
  const [assistantList, setAssistantList] = useState([]);
  const [categoryOptionsByLang, setCategoryOptionsByLang] = useState({});
  const [selectedCategoriesByLang, setSelectedCategoriesByLang] = useState({});

  const [isCopied, setIsCopied] = useState(false);

  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [loadedLanguages, setLoadedLanguages] = useState(new Set(['en']));
  const [translationIds, setTranslationIds] = useState({});
  const [attachmentByLang, setAttachmentByLang] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [languageToDelete, setLanguageToDelete] = useState(null);
  const [translationLangCode, setTranslationLangCode] = useState({});
  const [categoriesByLang, setCategoriesByLang] = useState({});
  const normalizeLang = (lang) => (lang === 'zh-TW' ? 'hk' : lang);

  const [formDataByLang, setFormDataByLang] = useState({
    en: { ...inputData }
  });
  useEffect(() => {
    setUploadData(attachmentByLang[currentLanguage] || []);
  }, [currentLanguage]);
  useEffect(() => {
    setAttachmentByLang((prev) => ({
      ...prev,
      [currentLanguage]: uploadData,
    }));
  }, [uploadData]);

  useEffect(() => {
    setIsCopied(false);
  }, [currentLanguage]);

  const handleDeleteLanguage = async () => {
    const lang = languageToDelete;
    const translationId = translationIds[lang];

    if (!translationId) return;

    try {
      await AxiosAPI({
        method: 'delete',
        url: `${deleteAPI_FormLanguageVersions_By_FormId}/${id}/${normalizeLang(lang)}`,
      });

      setTranslationIds((prev) => {
        const copy = { ...prev };
        delete copy[lang];
        return copy;
      });

      setFormDataByLang((prev) => ({
        ...prev,
        [lang]: { ...inputData },
      }));

      setAttachmentByLang((prev) => {
        const copy = { ...prev };
        delete copy[lang];
        return copy;
      });

      setLoadedLanguages((prev) => {
        const set = new Set(prev);
        set.delete(lang);
        return set;
      });

      setSelectedTag([]);
      setUploadData([]);
      setCurrentLanguage('en');
    } catch (err) {
      console.error('Delete language failed', err);
    } finally {
      setShowDeleteModal(false);
      setLanguageToDelete(null);
    }
  };

  const currentForm = formDataByLang[currentLanguage] || formDataByLang.en || inputData;

  const updateCurrentForm = (name, value) => {
    setFormDataByLang((prev) => {
      const currentLangData = prev[currentLanguage] || prev.en || { ...inputData };
      return {
        ...prev,
        [currentLanguage]: {
          ...currentLangData,
          [name]: value,
          __touched: true,
        },
      };
    });
  };


  const toggleGlobelToolTip = () => {
    setGlobelToolTip(!globelToolTip);
  };
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_FormsBy_Id}/${id}`,
      })
        .then((res) => {
          const data = res.data;

          if (data.attachmentFiles && data.attachmentFiles.length > 0) {
            setAttachmentByLang((prev) => ({
              ...prev,
              en: data.attachmentFiles,
            }));

            if (currentLanguage === 'en') {
              setUploadData(data.attachmentFiles);
            }
          } else {
            setAttachmentByLang((prev) => ({
              ...prev,
              en: [],
            }));
          }

          if (data.categories?.length > 0) {
            setSelectedCategoriesByLang((prev) => ({
              ...prev,
              en: data.categories.map((x) => ({
                label: x,
                value: x,
              })),
            }));

          }

          setInputData((prev) => ({
            ...prev,
            isGlobal: data.isGlobal || false,
          }));

          setFormDataByLang((prev) => ({
            ...prev,
            en: {
              ...prev.en,
              name: data.name || '',
              formType: data.formType || '0',
              subject: data.subject || '',
              subTitle: data.subTitle || '',
              successMessage: data.successMessage || '',
              formContent: data.formContent || '',
              dynamicConversationFlow: data.dynamicConversationFlow || '',
            },
          }));
        })
        .catch((err) => console.log('Error loading form:', err));
    }
    AxiosAPI({
      method: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${locale}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        var list = [];
        if (setslist !== null && setslist.length > 0) {
          setslist
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => {
              list.push({ id: l.openAiAssistantId, name: l.name });
            });
        }

        setAssistantList(list);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  }, [id]);


  useEffect(() => {
    if (!formDataByLang[currentLanguage] && formDataByLang.en) {
      setFormDataByLang((prev) => ({
        ...prev,
        [currentLanguage]: {
          ...prev.en,
          languageCode: currentLanguage,
          __touched: false,
        },
      }));
    }
  }, [currentLanguage, formDataByLang]);

  useEffect(() => {
    if (!id || currentLanguage === 'en') return;
    if (
      id &&
      currentLanguage !== 'en' &&
      !loadedLanguages.has(currentLanguage)
    ) {
      AxiosAPI({
        method: 'get',
        url: gAPI_FormLanguageVersion_ByFormAndLanguage,
        params: {
          formId: id,
          languageCode: normalizeLang(currentLanguage),
        },
      })
        .then((res) => {
          const translation = res.data;
          if (
            translation.languageVersionId === null &&
            !formDataByLang[currentLanguage]?.__touched
          ) {
            setFormDataByLang((prev) => ({
              ...prev,
              [currentLanguage]: {
                ...prev.en,           // copy parent once
                languageCode: currentLanguage,
                __touched: false,
              },
            }));
            setSelectedCategoriesByLang((prev) => ({
              ...prev,
              [currentLanguage]: prev.en || [],
            }));


            setAttachmentByLang((prev) => ({
              ...prev,
              [currentLanguage]: attachmentByLang.en || [],
            }));

            return;
          }
          if (translation) {
            setTranslationIds((prev) => ({
              ...prev,
              [currentLanguage]: translation.languageVersionId,
            }));
            setTranslationLangCode((prev) => ({
              ...prev,
              [currentLanguage]: translation.languageCode,
            }));

            setAttachmentByLang((prev) => ({
              ...prev,
              [currentLanguage]: translation.attachmentFiles || [],
            }));

            setUploadData(translation.attachmentFiles || []);
            if (translation.categories?.length > 0) {
              setSelectedCategoriesByLang((prev) => ({
                ...prev,
                [currentLanguage]: translation.categories.map((x) => ({
                  label: x,
                  value: x,
                })),
              }));

            } else {
              setSelectedCategoriesByLang((prev) => ({
                ...prev,
                [currentLanguage]: [],
              }));
            }

            setFormDataByLang((prev) => ({
              ...prev,
              [currentLanguage]: {
                ...prev[currentLanguage],
                name: translation.name || '',
                subject: translation.subject || '',
                subTitle: translation.subTitle || '',
                successMessage: translation.successMessage || '',
                formContent: translation.formContent || '',
                formType: translation.formType || '0',
                dynamicConversationFlow:
                  translation.dynamicConversationFlow || '',
                __touched: false,
              },
            }));
          }
        })

        .catch((err) => {
          console.log(`No translation found for ${currentLanguage}`, err);
        })
        .finally(() => {
          setLoadedLanguages((prev) => new Set(prev).add(currentLanguage));
        });
    }
  }, [currentLanguage, id, loadedLanguages]);

  // Fetch category list when language changes
  useEffect(() => {
    const apiLang = normalizeLang(currentLanguage);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_FormsCategoryList}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${apiLang}`,
    }).then((res) => {
      var category = [{ label: "Add New", value: "-1" }];
      res.data.map(l => category.push(l));
      setCategoryOptionsByLang((prev) => ({
        ...prev,
        [currentLanguage]: category,
      }));

    }).catch((err) => {
      console.error('Error fetching category list:', err);
    });
  }, [currentLanguage]);

  const AddUpload = () => {
    let links = [...uploadData];
    links.push({
      instruction: '',
      type: [],
      mandatory: false,
    });
    setUploadData(links);
  };
  const RemoveUpload = (index) => {
    const values = [...uploadData];
    values.splice(index, 1);
    setUploadData(values);
  };
  const handleChange = (e) => {
    updateCurrentForm(e.target.name, e.target.value);
  };

  const handleCheckedGlobal = (e) => {
    setInputData({
      ...inputData,
      isGlobal: e.target.checked,
    });
  };
  function validateJson(json) {
    try {
      JSON.parse(json);
      return true;
    } catch {
      return false;
    }
  }

  const handleSubmit = async () => {
    const dataToSave = formDataByLang[currentLanguage] || formDataByLang.en || inputData;
    const isEnglish = currentLanguage === 'en';
    const parentExists = Boolean(id);
    const translationId = translationIds[currentLanguage] ?? null;

    // ---------- VALIDATION ----------
    if (!dataToSave.formContent) {
      setError({ msg: 'please enter content!', visible: true });
      return;
    }

    if (!validateJson(dataToSave.formContent)) {
      setError({ msg: 'json is not valid!', visible: true });
      return;
    }

    setError({ msg: '', visible: false });

    try {

      if (isEnglish) {
        const parentPayload = {
          groupId: getGroupID(),
          propertyId: propertyId === '-1' ? null : propertyId,
          name: dataToSave.name,
          formType: dataToSave.formType,
          formContent: dataToSave.formContent,
          languageCode: 'en',
          subject: dataToSave.subject,
          subTitle: dataToSave.subTitle,
          successMessage: dataToSave.successMessage,
          isGlobal: inputData.isGlobal,
          categories: (selectedCategoriesByLang.en || []).map(t => t.value),
          dynamicConversationFlow: dataToSave.dynamicConversationFlow,
          attachmentFiles: attachmentByLang.en || [],
          creator: 'dashboard',
          updator: 'dashboard',
          status: 'Active',
        };

        if (!parentExists) {
          await AxiosAPI({
            method: 'post',
            url: postAPI_Create_Forms,
            data: parentPayload,
          });
        } else {
          await AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Forms}/${id}`,
            data: parentPayload,
          });
        }

        toggle();
        LoadData('en')
        return;
      }

      let parentFormId = id;
      let isParentJustCreated = false;

      if (!parentExists) {
        const parentFromChildPayload = {
          groupId: getGroupID(),
          propertyId: propertyId === '-1' ? null : propertyId,
          name: dataToSave.name,
          formType: dataToSave.formType,
          formContent: dataToSave.formContent,
          languageCode: 'en',
          isGlobal: inputData.isGlobal,
          categories: (selectedCategoriesByLang[currentLanguage] || []).map(t => t.value),
          dynamicConversationFlow: dataToSave.dynamicConversationFlow,
          attachmentFiles: [],
          creator: 'dashboard',
          status: 'Active',
        };

        const parentRes = await AxiosAPI({
          method: 'post',
          url: postAPI_Create_Forms,
          data: parentFromChildPayload,
        });

        parentFormId = parentRes.data.id;
        let isParentJustCreated = true;
      }
      if (parentExists && !isParentJustCreated) {
        const parentUpdatePayload = {
          groupId: getGroupID(),
          propertyId: propertyId === '-1' ? null : propertyId,

          // COMMON FIELDS (updated)
          formType: dataToSave.formType,
          dynamicConversationFlow: dataToSave.dynamicConversationFlow,
          isGlobal: inputData.isGlobal,

          // REQUIRED BUT UNCHANGED FIELDS
          name: formDataByLang.en.name,
          languageCode: 'en',
          formContent: formDataByLang.en.formContent,
          subject: formDataByLang.en.subject,
          subTitle: formDataByLang.en.subTitle,
          successMessage: formDataByLang.en.successMessage,
          categories: (selectedCategoriesByLang.en || []).map(t => t.value),
          attachmentFiles: attachmentByLang.en || [],
          status: 'Active',

          updator: 'dashboard',
        };

        await AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_Forms}/${parentFormId}`,
          data: parentUpdatePayload,
        });
      }


      const childPayload = {
        formId: parentFormId,
        languageCode: normalizeLang(currentLanguage),
        name: dataToSave.name,
        formContent: dataToSave.formContent,
        subject: dataToSave.subject,
        subTitle: dataToSave.subTitle,
        successMessage: dataToSave.successMessage,
        categories: (selectedCategoriesByLang[currentLanguage] || []).map(t => t.value),
        attachmentFiles: attachmentByLang[currentLanguage] || [],
        creator: 'dashboard',
        updator: 'dashboard',
        status: 'Active',
      };

      if (translationId === null) {
        await AxiosAPI({
          method: 'post',
          url: postAPI_CreateFormLanguageVersion,
          data: childPayload,
        });
      } else {
        await AxiosAPI({
          method: 'put',
          url: `${putAPI_UpdateFormLanguageVersion}/${translationId}`,
          data: childPayload,
        });
      }

      toggle();
      LoadData('en')

    } catch (err) {
      if (
        err.response?.data?.HttpStatusCode === 400 &&
        err.response?.data?.Messages?.length > 0
      ) {
        setMsg(err.response.data.Messages);
        setOpen(true);
      }
      console.error('Save Error', err);
    }
  };


  const hanleChangeUpload = (e, index, name) => {
    let media = [];
    let data = [...uploadData];
    if (name === 'instruction') {
      data[index].instruction = e.target.value;
    } else if (name === 'type') {
      media = e.map((a) => a.value);
      if (media.includes('jpg')) {
        media.push('jpeg');
      }
    }
    data[index].type = media;
    setUploadData(data);
  };
  const handleSwitchChange = (value, index) => {
    let data = [...uploadData];
    data[index].mandatory = value;
    setUploadData(data);
  };
  const handleChangeMultiCategory = (selected) => {
    if (selected.some(i => i.value === '-1')) {
      setAddTagModel(true);
      return;
    }

    setSelectedCategoriesByLang((prev) => ({
      ...prev,
      [currentLanguage]: selected,
    }));
  };


  const addTag = (tagName) => {
    const newOption = { label: tagName, value: tagName };

    setCategoryOptionsByLang((prev) => ({
      ...prev,
      [currentLanguage]: [
        ...(prev[currentLanguage] || []),
        newOption,
      ],
    }));


    setSelectedCategoriesByLang((prev) => ({
      ...prev,
      [currentLanguage]: [
        ...(prev[currentLanguage] || []),
        newOption,
      ],
    }));


    setAddTagModel(false);
  };

  const setLanguage = (lang) => {
    setCurrentLanguage(lang);
  };

  const isEnglish = currentLanguage === 'en';

  const isTranslationExists =
    translationIds[currentLanguage] !== null &&
    translationIds[currentLanguage] !== undefined;

  const actionLabel = isEnglish
    ? formLabel
    : isTranslationExists
      ? 'Update'
      : 'Save';

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          {actionLabel} <IntlMessages id="forms.forms-title" />
        </ModalHeader>
        <ModalBody>
          <LanguageTabs
            selectedTab={currentLanguage === "hk" ? "zh-TW" : currentLanguage}
            setLanguage={setLanguage}
            propertyId={propertyId}
          />

          <TabContent activeTab={currentLanguage}>
            <TabPane tabId={currentLanguage}>
              <Row>
                <Colxx md="4">
                  <Row className="mb-4">
                    <Colxx xxs="12" className="mb-2">
                      <Label>Title</Label>
                      <Input
                        type="text"
                        value={currentForm.name}
                        name="name"
                        onChange={handleChange}
                      />
                    </Colxx>
                    <Colxx xxs="12" className="mb-2">
                      <Label>Form Type</Label>
                      <Input
                        type="select"
                        value={currentForm.formType}
                        name="formType"
                        onChange={handleChange}
                      >
                        <option value="0">Select</option>
                        <option value="LeaveDetails">Leave Details</option>
                        <option value="Pre">Pre</option>
                        <option value="Post">Post</option>
                        <option value="Feedback">Feedback</option>
                        <option value="GroupBooking">Group Booking</option>
                        <option value="LongStay">Long Stay</option>
                        <option value="LostFound">Lost & Found</option>
                        <option value="InvoiceRequest">Invoice Request</option>
                        <option value="InStay">In Stay</option>
                        <option value="CheckIn">Check-In</option>
                        <option value="WorkOrder">Work Order</option>
                      </Input>
                    </Colxx>
                    <Colxx xxs="12" className="mb-2">
                      <Label>Form Category </Label>
                      <Select
                        components={{ Input: CustomSelectInput }}
                        className="react-select"
                        classNamePrefix="react-select"
                        isMulti={true}
                        name="form-field-name"
                        value={selectedCategoriesByLang[currentLanguage] || []}
                        onChange={handleChangeMultiCategory}
                        options={categoryOptionsByLang[currentLanguage] || []}
                      />
                    </Colxx>
                    <Colxx xxs="12" className="mb-2">
                      <Label>Subject</Label>
                      <Input
                        type="text"
                        value={currentForm.subject}
                        name="subject"
                        onChange={handleChange}
                      />
                    </Colxx>
                    <Colxx xxs="12" className="mb-2">
                      <Label>Subtitle</Label>
                      <Input
                        type="textarea"
                        value={currentForm.subTitle}
                        name="subTitle"
                        onChange={handleChange}
                        rows={2}
                      />
                    </Colxx>
                    <Colxx xxs="12" className="mb-2">
                      <Label>Success Message</Label>
                      <Input
                        type="textarea"
                        value={currentForm.successMessage}
                        name="successMessage"
                        onChange={handleChange}
                        rows={2}
                      />
                    </Colxx>

                    {isSuperAdmin && isSuperAdmin === true && (
                      <div>
                        {assistantList && assistantList.length > 0 && (
                          <Colxx xxs="12" className="mb-2">
                            <Label>Execute Dynamic Conversation Flow on Form Submission <span style={{ fontSize: '10px' }}>(Only visible to Super Admins)</span> </Label>
                            <Input
                              type="select"
                              name="dynamicConversationFlow"
                              placeholder="Dynamic Conversation Flow"
                              value={currentForm?.dynamicConversationFlow}
                              onChange={handleChange}
                            >
                              <option value="">
                                Select a Dynamic Conversation Flow
                              </option>
                              {assistantList.map((assist, index) => (
                                <option key={index} value={assist.id}>
                                  {`${assist.name} (${assist.id})`}
                                </option>
                              ))}
                            </Input>
                          </Colxx>
                        )}
                      </div>
                    )}
                  </Row>
                </Colxx>
                <Colxx md="8">
                  <Row>
                    <Colxx
                      xxs="12"
                      className="mb-2 av-tooltip tooltip-label-right"
                    >
                      <Label className="">Form Content</Label>
                      <Input
                        type="textarea"
                        value={currentForm?.formContent}
                        name="formContent"
                        rows={13}
                        onChange={handleChange}
                      />
                      {error.visible && (
                        <div
                          className="invalid-feedback d-block"
                          style={{ marginLeft: '60px' }}
                        >
                          {error.msg}
                        </div>
                      )}
                    </Colxx>
                    <Colxx xxs="12" className="mb-2">
                      {uploadData &&
                        uploadData.length > 0 &&
                        uploadData.map((item, i) => (
                          <Row>
                            <Colxx xxs="6">
                              <Label>Instructions</Label>
                              <Input
                                type="textarea"
                                value={item.instruction}
                                name="instruction"
                                onChange={(e) =>
                                  hanleChangeUpload(e, i, 'instruction')
                                }
                                rows={4}
                              />
                            </Colxx>
                            <Colxx xxs="5">
                              <Row>
                                <Colxx xxs="12">
                                  <Label>Media Type</Label>
                                  <Select
                                    components={{ Input: CustomSelectInput }}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    isMulti={true}
                                    name="form-field-name"
                                    value={mediaTypeList.filter(
                                      (i) =>
                                        item.type && item.type.includes(i.value)
                                    )}
                                    onChange={(e) =>
                                      hanleChangeUpload(e, i, 'type')
                                    }
                                    options={mediaTypeList}
                                  />
                                </Colxx>
                                <Colxx xxs="12">
                                  <Label>Mandatory?</Label>
                                  <Switch
                                    className=" agentswitch custom-switch-primary custom-switch-small"
                                    checked={item.mandatory}
                                    onChange={(primary) =>
                                      handleSwitchChange(primary, i)
                                    }
                                  />
                                </Colxx>
                              </Row>
                            </Colxx>
                            <Colxx xxs="1">
                              <Button
                                style={{ marginTop: '2rem' }}
                                color="danger"
                                size="xs"
                                outline
                                onClick={() => RemoveUpload(i)}
                              >
                                -
                              </Button>
                            </Colxx>
                          </Row>
                        ))}
                      <Button
                        className="mt-2"
                        color="secondary"
                        size="xs"
                        outline
                        onClick={() => AddUpload()}
                      >
                        + File Upload
                      </Button>
                    </Colxx>
                  </Row>
                </Colxx>
              </Row>
              <Row>
                <Colxx xxs="12">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CustomInput
                      type="checkbox"
                      id="is_globel"
                      label="Make this item globel i.e visible across all properties"
                      checked={inputData.isGlobal}
                      onChange={handleCheckedGlobal}
                    />{' '}
                    <i
                      className="demo-icon simple-icon-info ml-2"
                      id="globeltip"
                    ></i>
                    <Tooltip
                      placement="right"
                      isOpen={globelToolTip}
                      target="globeltip"
                      toggle={toggleGlobelToolTip}
                    >
                      <p className="text-left">
                        This item will be visible across all the properties in
                        your group. Any changes will reflect across all the
                        properties where you are showing this item.
                        <br />
                        <br />
                        You can change the status to “Inactive” at property
                        level, if you don’t want to show for a particular
                        property.
                      </p>
                    </Tooltip>
                  </div>
                </Colxx>
              </Row>
            </TabPane>
          </TabContent>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            {actionLabel}
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          {currentLanguage !== 'en' &&
            translationLangCode[currentLanguage] !== 'en' &&
            translationIds[currentLanguage] && (
              <div className="mb-1 w-15 w-sm-100">
                <CopyToClipboard
                  text={
                    (service !== null && service !== undefined && service !== ''
                      ? `https://chatapps.${service}`
                      : process.env.REACT_APP_BASE_CHATUI) +
                    '/form-view?id=' +
                    id +
                    '&gid=' +
                    getGroupID() +
                    '&pid=' +
                    propertyId +
                    '&lang=' +
                    currentLanguage +
                    ''
                  }
                  onCopy={() => {
                    setIsCopied(true);
                  }}
                >
                  <Button
                    color="secondary"
                    className="btn-sm"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      height: '39px',
                      fontSize: '12px',
                      padding: '0 19px',
                    }}
                  >
                    <FontAwesomeIcon icon={isCopied ? faCheck : faCopy} />
                    {isCopied ? 'Copied!' : 'Copy Link'}
                  </Button>
                </CopyToClipboard>
              </div>
            )}
          {currentLanguage !== 'en' &&
            translationLangCode[currentLanguage] !== 'en' &&
            translationIds[currentLanguage] && (
              <Button
                color="danger"
                onClick={() => {
                  setLanguageToDelete(currentLanguage);
                  setShowDeleteModal(true);
                }}
              >
                Delete
              </Button>
            )}
        </ModalFooter>
        <Validation
          open={open}
          messages={msg}
          toggle={() => {
            setOpen(!open);
          }}
        ></Validation>
      </Modal>
      {addTagModel && (
        <CategoryTag
          visible={addTagModel}
          toggle={() => setAddTagModel(false)}
          addTag={(e) => addTag(e)}
        ></CategoryTag>
      )}
      {showDeleteModal && (
        <Modal
          isOpen={showDeleteModal}
          toggle={() => setShowDeleteModal(false)}
        >
          <ModalHeader toggle={() => setShowDeleteModal(false)}>
            Confirm Delete
          </ModalHeader>

          <ModalBody>
            <p>
              Are you sure you want to delete this language version?
              <br />
              <b>This action cannot be undone.</b>
            </p>
          </ModalBody>

          <ModalFooter>
            <Button color="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>

            <Button color="danger" onClick={handleDeleteLanguage}>
              Yes, Delete
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Fragment>
  );
}
const mapStateToProps = ({ settings, usersListApp }) => {
  const { propertyId, locale } = settings;
  const { isSuperAdmin } = usersListApp;
  return {
    propertyId,
    locale,
    isSuperAdmin,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Forms));
